import { Styles } from 'react-jss'
import colors from 'lib/colors'
import { cssVarColors, cssVarTextColors } from 'lib/cssSelector'
const { white } = cssVarTextColors
const { main } = cssVarColors

export const sheet: Styles = {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '7px 10px',
    borderRadius: '25px',
    whiteSpace: 'nowrap',
    boxSizing: 'border-box'
  },
  icon: {
    width: 14,
    height: 14,
    flexShrink: 0
  }
}
